// LEN-213 (designer D4): process versions (Lender.Optimus.Ai AiProcessVersionsController). A draft is captured from the
// live config (or copied from a version, or imported), tested on stored runs (read-only, no model call) against the
// published version, its differences acknowledged, then published (owner only). Export bundles are signed; an import
// validates first (dry run) and only ever creates a draft.
export class AiProcessVersionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getVersions({ processId, signal } = {}) {
    return this.#http.get(`/api/ai-config/processes/${processId}/versions`, { signal });
  }

  async getVersion({ versionId, signal }) {
    return this.#http.get(`/api/ai-config/process-versions/${versionId}`, { signal });
  }

  async createDraft({ processId, from = 'live', replaceDraft = false, label = null }) {
    return this.#http.post(`/api/ai-config/processes/${processId}/versions/draft`, {
      from,
      replaceDraft,
      label,
    });
  }

  async getDiff({ processId, from, to, signal }) {
    return this.#http.get(`/api/ai-config/processes/${processId}/versions/diff`, {
      params: { from, to },
      signal,
    });
  }

  async testDraft({ versionId, lastRuns = null, runIds = null }) {
    return this.#http.post(`/api/ai-config/process-versions/${versionId}/test`, {
      lastRuns,
      runIds,
    });
  }

  async acknowledge({ versionId, expectedSha256, notes }) {
    return this.#http.put(`/api/ai-config/process-versions/${versionId}/acknowledgements`, {
      expectedSha256,
      notes,
    });
  }

  async publish({ versionId, expectedSha256, notes, label = null }) {
    return this.#http.post(`/api/ai-config/process-versions/${versionId}/publish`, {
      expectedSha256,
      notes,
      label,
    });
  }

  async deleteDraft({ versionId }) {
    return this.#http.delete(`/api/ai-config/process-versions/${versionId}`);
  }

  // The bundle is kept as the exact text the server wrote (parsing and re-serializing could change a number's text).
  async exportBundle({ processId, version }) {
    return this.#http.get(
      `/api/ai-config/processes/${processId}/versions/${encodeURIComponent(version)}/export`,
      { responseType: 'text', transformResponse: [data => data] },
    );
  }

  // The bundle is sent as the exact text of the file: its digest is over that payload.
  async importBundle({ processId, bundleText, dryRun = true, replaceDraft = false }) {
    return this.#http.post(`/api/ai-config/processes/${processId}/versions/import`, bundleText, {
      params: { dryRun, replaceDraft },
      headers: { 'Content-Type': 'application/json' },
      transformRequest: [data => data],
    });
  }
}
